import * as d3 from 'd3';

import { ShapeFormat } from '../../models';
import { notNaN } from '../../helpers/RoundingHelper';


export class ShapeRenderer {
    private _xScale: d3.scale.Linear<number, number>;
    private _yScale: d3.scale.Linear<number, number>;

    constructor(private _container: d3.Selection<any>) {

    }

    data(data: ShapeFormat[]) {
        const dataBound = this._container.selectAll('.shape')
            .data(data);
        dataBound
            .exit()
            .remove();
        const enterSelection = dataBound
            .enter()
            .append('g')
            .classed('shape', true);
        enterSelection.append('path')
            .classed('shape-line', true);
        enterSelection.append('g')
            .classed('shape-points', true);
        this.update(dataBound);
    }

    xScale(scale: d3.scale.Linear<number, number>): this {
        this._xScale = scale;
        this.update(this._container.selectAll('.shape'));
        return this;
    }

    yScale(scale: d3.scale.Linear<number, number>): this {
        this._yScale = scale;
        this.update(this._container.selectAll('.shape'));
        return this;
    }

    private update(group: d3.Selection<ShapeFormat>) {
        const gen = d3.svg.line<{ x: number; y: number }>()
            .x(d => notNaN(this._xScale(d.x), 0))
            .y(d => notNaN(this._yScale(d.y), 0))
            .defined(d => d.x !== null && d.y !== null);
        group
            .select('path.shape-line')
            .style('fill', d => d.isFilled ? d.color : 'transparent')
            .style('stroke', d => d.isLineVisible ? d.color : null)
            .style('stroke-width', d => d.thickness ? d.thickness : 1)
            .attr('d', d => gen.interpolate(d.interpolate)(d.points));
        this.updatePoints(group);
    }

    private updatePoints(group: d3.Selection<ShapeFormat>) {
        const pointsGroup = group.select('.shape-points')
            .classed('hidden-group', d => !d.isSymbolVisible)
            .style('fill', d => d.color);
        const dataBound = pointsGroup.selectAll('.point')
            .data(d => {
                d.points.forEach(p => p.symbol = d.symbol);
                return d.points as { x: number; y: number; symbol: string }[];
            });
        dataBound
            .exit()
            .remove();
        dataBound
            .enter()
            .append('g')
            .classed('point', true)
            .append('path');
        dataBound
            .attr('transform', (d, i) => `translate(${notNaN(this._xScale(d.x), 0)},${notNaN(this._yScale(d.y), 0)})`)
            .select('path')
            .attr('d', d => d3.svg.symbol().type(d.symbol)(d));
        return group;
    }
}